import { Information } from "../../../../domain/entities/information";
import informationUseCases from "../../../../domain/usecase/impl/information/informationUseCases";
import { ActionTree, Module } from "vuex";

class InformationState {
  information: Information = new Information();
  informations: Information[] = Array<Information>();

  informationsLandingPage: Information[] = Array<Information>();
}

const state = new InformationState();

const mutations = {
  SET_INFORMATIONS(state: InformationState, informations: Information[]): void {
    state.informations = informations;
  },
  SET_INFORMATION(state: InformationState, information: Information): void {
    state.information = information;
  },
  SET_INFORMATIONS_LANDING_PAGE(
    state: InformationState,
    informationsLandingPage: Information[]
  ): void {
    state.informationsLandingPage = informationsLandingPage;
  },
};

const actions: ActionTree<InformationState, InformationState> = {
  async list({ commit }): Promise<void> {
    try {
      const response: Information[] = await informationUseCases.list();
      commit("SET_INFORMATIONS", response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  async listLandingPage({ commit }): Promise<void> {
    try {
      const response: Information[] = await informationUseCases.listLandingPage();
      commit("SET_INFORMATIONS_LANDING_PAGE", response);
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
};

const getters = {
  information: (state: InformationState): Information => state.information,
  informations: (state: InformationState): Information[] => state.informations,

  informationsLandingPage: (state: InformationState): Information[] =>
    state.informationsLandingPage,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
} as Module<InformationState, InformationState>;
